import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700
}))

export const SpinnerContainer = styled('div', ({ $theme }) => ({
    padding: `0 ${$theme.sizing.scale700}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
}))
